/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClaimImageRequest } from './CreateClaimImageRequest';
export type TakeoutClaimRequest = {
    takeoutAt: string;
    isReturnProduct: boolean;
    status: TakeoutClaimRequest.status;
    paymentType: TakeoutClaimRequest.paymentType;
    paymentMethod?: TakeoutClaimRequest.paymentMethod;
    compensationAmount?: number;
    slipImages?: Array<CreateClaimImageRequest>;
    repairImages?: Array<CreateClaimImageRequest>;
    guaranteeDay: number;
    guaranteeHtmlDetail: string;
    remark?: string;
};
export namespace TakeoutClaimRequest {
    export enum status {
        NONE = 'NONE',
        RECEIVE = 'RECEIVE',
        ORDER_SPARE = 'ORDER_SPARE',
        RECEIVE_SPARE = 'RECEIVE_SPARE',
        REPAIRING = 'REPAIRING',
        TESTING = 'TESTING',
        REPAIR_SUCCESS = 'REPAIR_SUCCESS',
        REPAIR_FAIL = 'REPAIR_FAIL',
        CANCEL = 'CANCEL',
    }
    export enum paymentType {
        NONE = 'NONE',
        DEPOSIT = 'DEPOSIT',
        DEPOSIT_REFUND = 'DEPOSIT_REFUND',
        INSTALLMENT = 'INSTALLMENT',
        FULL_PAYMENT = 'FULL_PAYMENT',
        COMPENSATION = 'COMPENSATION',
        REFUND_COMPENSATION = 'REFUND_COMPENSATION',
        HIRE = 'HIRE',
    }
    export enum paymentMethod {
        NONE = 'NONE',
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        BANK_TRANSFER = 'BANK_TRANSFER',
    }
}

